// extracted by mini-css-extract-plugin
export default {"label__extra":"addElement_label__extra__53hjP"};